import React from 'react';

const AccountPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="text-center">
          <h1 className="text-3xl font-bold text-gray-900 mb-4">החשבון שלי</h1>
          <p className="text-gray-600">בקרוב - ניהול פרופיל אישי</p>
        </div>
      </div>
    </div>
  );
};

export default AccountPage;
